import { replace } from 'connected-react-router';

/**
 * Правильнее было сделать редиректы через экшены роутера, и
 * слушать их в саге роутера, но такие экшены не запускаются при
 * серверном рендеринге, поэтому при ошибке загрузке данных в саге
 * сразу вызывается replace на страницу not-found.
 */
export function redirectToNotFound() {
    return redirectTo('/not-found');
}

export default function redirectTo(pathname: string) {
    return replace({ pathname });
}
